import { ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** 라우트(pathname) 변경 시 스크롤을 맨 위로 이동 */
export const ScrollToTop = ({ children }: { children: ReactNode }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <>{children}</>;
};
